import {
  Box,
  Container,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  Text,
  HStack,
  Stack,
  Badge,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import { useHistory } from "react-router-dom";
// import WalletTransfer from "components/WalletTransfer/WalletTransfer";
// import { useCallback, useMemo, useState } from "react";
import Button from "components/Button/Button";
// import { NumberInputWithMax } from "components/Input/NumberInput";
// import toPrecision from "util/toPrecision";

import { ReactComponent as AddCircleIcon } from "assets/svg/add-circle.svg";
import toCoinLocale from "util/toCoinLocale";
import StakeInfo from "components/StakeInfo/StakeInfo";
import { useGetStakingsQuery } from "services/walletApi";
import constant from "config/constant";

export default function AvailableEarnings(props) {
  const currentPage = "Earn";

  const params = new URLSearchParams(props?.location?.search);

  //   const { coin } = useParams();
  const history = useHistory();

  const { data } = useGetStakingsQuery();

  console.log("Earnings", data);

  //   const [state, _set] = useState({
  //     coin,
  //     from: params.get("from") ?? "earn",
  //     to: params.get("to") ?? "main",
  //   });

  //   const set = useCallback(
  //     (update) => _set((old) => ({ ...old, ...update })),
  //     []
  //   );

  // console.log("Transfer", state);

  //   const isDisabled = useMemo(
  //     () => !(state?.coin && state?.from && state?.to && state?.amount),
  //     [state]
  //   );

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 30vw)", "calc(100% - 45vw)"]}
            m="0"
            // p="0"
          >
            <Box px={["0", "0", "0"]}>
              <Heading fontSize="3xl">Coin Available</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/wallet`}>
                    Wallet
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink
                    to={`/dashboard/wallet/${params.get("coin")}?tab=earn`}
                  >
                    Earn
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Subscriptions
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <HStack justifyContent="flex-end" mb="18px">
              <Button
                // disabled={!isEligible}
                variant="ghost"
                bg="transparent"
                size="sm"
                color="#03A438"
                onClick={() => {
                  history.push(
                    `/dashboard/earn/subscribe?coin=${params.get("coin")}`
                  );
                }}
              >
                <HStack>
                  <Box as={AddCircleIcon} />
                  <Text>Subscribe</Text>
                </HStack>
              </Button>
            </HStack>

            <Box
              bg="white"
              mt="20px"
              p={["24px", "56px"]}
              borderRadius={[0, "16px"]}
              border="1px solid #EFF0F7"
            >
              <Stack>
                {constant.supportedStakableCoins.map((coin) => (
                  <StakeInfo
                    coin={coin}
                    title={toCoinLocale(coin)}
                    _child={{ top: "20px", left: "142px" }}
                    onClick={() => {
                      history.push(`/dashboard/earn/earnings/${coin}`);
                    }}
                  >
                    <Badge
                      px="10px"
                      borderRadius="16px"
                      bg="#CEEEE1"
                      color="var(--primary)"
                    >
                      20%
                    </Badge>
                  </StakeInfo>
                ))}
              </Stack>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
